var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.61,5.22V6.64L19.49,8.76l-.71-.71-.71-.71,1.42-1.41L18.07,4.51,16.66,5.93,16,5.22l-.71-.71,2.12-2.12h1.42ZM16.66,8.76,6.22,19.2l-2.12.7.7-2.12L15.24,7.34l-.7-.7-.71-.71L3.22,16.54,3,16.93,1.57,21.17l1.26,1.26L7.07,21l.39-.24L18.07,10.17,16.66,8.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/1787821308/media/icon-pencil.5007c446b1b3a6e98b4b6172b0195ebf.svg";
export { ForwardRef as ReactComponent };